import { Box } from '@mui/material';
import { DATA_TEST } from './enums';
import type { ResultActionsProps } from './types';

/**
 * Renders the actions (buttons, links, etc.) for the Result component.
 */
export const ResultActions = ({ children, dataTest, ...props }: ResultActionsProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: '1rem',
        gap: '0.25rem'
      }}
      data-test={dataTest ?? DATA_TEST.result_actions}
      {...props}
    >
      {children}
    </Box>
  );
};
